import { useContext, useId } from "react";
import { ReactReduxContext } from "react-redux";
import clsx from "clsx";
import PropTypes from 'prop-types';
import { CONTACTSPERPAGE } from "../../../../constants/Constants";
import { Localize as AriaLocalize } from "../../../../shared/ariaLabelLocalize";

const PaginationSize = ({ paginationProps }) => {
  const reduxContext = useContext(ReactReduxContext);
  const ariaLangId = reduxContext?.store?.getState()?.language?.selectedlanguage?.id;
  const t = AriaLocalize[ariaLangId] || AriaLocalize['en_US'];
  // useId() gives each instance a unique DOM id, so multiple PaginationSize
  // components on the same page (e.g. once per data table) don't collide on
  // the hardcoded "page-size-dropdown" id (WCAG 4.1.1 duplicate ID fix).
  const dropdownId = useId();
  const {
    sizePerPageList,
    sizePerPage,
    totalSize,
    onSizePerPageChange = CONTACTSPERPAGE,
  } = paginationProps;

  const onSizeChange = (newSize) => {
    onSizePerPageChange(newSize);
  };

  return (
    <div className="page-result-size">
      <div className="first-label">Show</div>
      <div className="dropdown page-result-dropdown top-dropdown">
        <button
          className="btn dropdown-toggle triangle-none btn-sm"
          type="button"
          id={dropdownId}
          data-bs-toggle="dropdown"
          aria-haspopup="menu"
          aria-expanded="false"
          aria-label={t.rows_per_page_currently.replace('{n}', sizePerPage)}
          disabled={totalSize === 0}
        >
          <span className="btn-text">{sizePerPage}</span>
          <span className="dropdown-toggle-arrow icon-arrow-down"></span>
        </button>
        <div className="dropdown-menu" aria-labelledby={dropdownId} role="menu">
          <div className="dropdown-menu-in form-type-list custom-scroll-div-thin">
            <ul role="none">
              {sizePerPageList.map((option) => {
                const isSelect = sizePerPage === option.value;
                return (
                  <li key={option.value} role="none">
                    <button
                      type="button"
                      className={clsx(
                        "btn dropdown-item",
                        isSelect && "active"
                      )}
                      onClick={() => onSizeChange(option.value)}
                      role="menuitemradio"
                      aria-checked={isSelect}
                      tabIndex={-1}
                    >
                      <span className="dropdown-item-text">{option.text}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className="last-label">rows</div>
    </div>
  );
};

PaginationSize.propTypes = {
  paginationProps: PropTypes.object,
};

export default PaginationSize;
